(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/config/menu-config/assets/javascripts/navigation-menu.js') >= 0) return;  svs.modules.push('/components/config/menu-config/assets/javascripts/navigation-menu.js'); 'use strict'; 

const loginAndCreateUserLinks = document.querySelectorAll('.nav-menu-header-button, .navigation-user-logged-out a');

for (let i = 0, length = loginAndCreateUserLinks.length; i < length; i++) {
  const link = loginAndCreateUserLinks[i];
  link.addEventListener('click', e => {
    e.preventDefault();

    if (location.pathname === svs.core.urlMapping.get('loginHome') && e.currentTarget.getAttribute('href') === svs.core.urlMapping.get('loginHome')) {
      location.reload();
    } else if (location.pathname === svs.core.urlMapping.get('loginHome') && e.currentTarget.getAttribute('href') === svs.core.urlMapping.get('customerRegistrationHome')) {
      svs.utils.url.refreshQueryString();
      const {
        returnUrl,
        extra
      } = svs.utils.url.queryString;
      const delim = location.href.indexOf('?') > -1 ? '&' : '?';
      const loginParams = [];

      if (!returnUrl) {
        loginParams.push("returnUrl=".concat(encodeURIComponent(svs.core.urlMapping.get('startPage'))));
      }

      if (!extra) {
        loginParams.push("extra=no");
      }

      const loginParamsString = loginParams.length > 0 ? delim + loginParams.join('&') : ''; 

      location.href = "".concat(e.currentTarget.getAttribute('href') + svs.utils.url.currentPathEncodedParams().replace(svs.core.urlMapping.get('loginHome'), '') + loginParamsString);
    } else {
      location.href = "".concat(e.currentTarget.getAttribute('href'), "?extra=no&returnUrl=").concat(svs.utils.url.currentPathEncodedParams());
    }
  });
}
 })(window);